import { h, Component } from 'preact';
import { BaseComponent } from '../../common/BaseComponent';
import { IQuestionsProps, IQuestionsState } from './IQuestions';
import { DynamicField } from '../forms/fields/dynamicField/DynamicField';
import { Answer } from '../../models/Answer';
import { bind } from 'decko';
import { QuestionType } from '../../enums/QuestionType';
import { TextBox } from '../forms/fields/textBox/TextBox';
import { RadioButtonList } from '../forms/fields/radioButtonList/RadioButtonList';
import { YesNoRadioButtons } from '../forms/fields/yesNoRadioButtons/YesNoRadioButtons';
import { CheckBox } from '../forms/fields/checkBox/CheckBox';
import { CheckBoxList } from '../forms/fields/checkBoxList/CheckBoxList';

import List from 'preact-material-components/List';
import { DocType } from '../../enums/DocType';
import { DocViewer } from '../docViewer/docViewer';
import { VideoPlayer } from '../videoPlayer/videoPlayer';

let style = require('./style.scss');

export class Questions extends BaseComponent<IQuestionsProps, IQuestionsState> {

    public answers: { [key: string]: Answer };

    constructor(props, ctx) {

        super(props, ctx);
        this.answers = {};
        this.initializeQuestions(this.props.questions);
    }

    @bind
    public onChange(id, value) {
        this.answers[id].text = value;
    }

    @bind
    public onYesNoChange(id, value) {
        this.answers[id].isChecked = value == 'true';
    }

    @bind
    public onRadioCheckBoxListChange(id, value) {
        this.answers[id].answerIds = value;
    }

    @bind
    public onCheckBoxChange(id, value) {
        this.answers[id].isChecked = value;
    }

    @bind
    public onDocOpened(id) {
        this.answers[id].isChecked = true;
    }



    private initializeQuestions(q) {

        q.forEach((val) => {
            this.answers[val.id] = new Answer({
                questionId: val.id, questionType: val.type, required: val.required
            });

            if (val.defaultValue)
                switch (val.type) {
                    case QuestionType.Text:
                        this.onChange(val.id, val.defaultValue);
                        break;
                    case QuestionType.Radio:
                        this.onRadioCheckBoxListChange(val.id, [val.defaultValue]);
                        break;
                    case QuestionType.YesNo:
                        this.onYesNoChange(val.id, val.defaultValue);
                        break;
                    case QuestionType.Checkbox:
                        this.onCheckBoxChange(val.id, val.defaultValue);
                        break;
                    case QuestionType.CheckBoxList:
                        this.onRadioCheckBoxListChange(val.id, val.defaultValue);
                        break;
                }
        });
        this.setState({ questions: q });
    }

    public showDocToDisplay(url: string, type: DocType) {
        this.modal.showMessageBox({
            message: this.getDocToDisplay(url, type),
            maxSize: type == DocType.Pdf,
            buttons: [
                {
                    text: "Ok",
                    onClick: () => {

                        if (type == DocType.Pdf)
                            this.refs.doc.destroy()
                        else if (type == DocType.Vimeo)
                            this.refs.video.destroy();

                        this.modal.hideDialog();
                    }
                }
            ]
        });
    }

    public getDocType(url: string): DocType {

        var lurl = url.toLowerCase();
        var imgExtensions = [".bmp", ".jpg", ".jpeg", ".png"];
        var docExtensions = [".pdf"];
        if (docExtensions.some((val) => { return lurl.endsWith(val); }))
            return DocType.Pdf;
        else if (lurl.indexOf("https://vimeo") > -1 || lurl.indexOf(".mp4") > -1)
            return DocType.Vimeo;
        else if (imgExtensions.some((val) => { return lurl.endsWith(val); }))
            return DocType.Image;
        else return DocType.Unknown;
    }

    public getDocToDisplay(url: string, type?: DocType) {
        type = type || this.getDocType(url);
        switch (type) {
            case DocType.Image:
                var f = () => { };
                var p = new Promise((res, rej) => {
                    f = () => { res(); }
                    this.modal.setState(s => { s.options.maxSize = true; return s; });
                });
                this.modal.showLoader(p);
                return <div class={`${style.popupImage}`}><img src={url} onLoad={f} /></div>
            case DocType.Pdf:
                return <DocViewer ref={this.setRef("doc")} url={url} />;
            case DocType.Vimeo:
                return <VideoPlayer ref={this.setRef("video")} url={url} playing />
        }
        return null;
    }

    public getAcknowledgementQuestion(id: string, title: string, message: string): Promise<boolean> {
        const key = String(id);


        (this as any).answers = (this as any).answers || {};
        if (!this.answers[key]) {
            this.answers[key] = {
                questionId: key,
                questionType: QuestionType.Acknowledgement,
                required: true,
                isChecked: false,
                text: '',
                answerIds: null
            };
        }

       
        const ensureAllAckAnswers = () => {
            const qsState: any = this.state && (this.state as any).questions;
            let list: any[] = [];
            if (Array.isArray(qsState)) list = qsState;
            else if (qsState && Array.isArray(qsState.questions)) list = qsState.questions;

            for (let i = 0; i < list.length; i++) {
                const q = list[i];
                const qType = (typeof q.type !== "undefined" ? q.type : q.questionType);
                if (qType === QuestionType.Acknowledgement) {
                    const ackKey = String(typeof q.id !== "undefined" ? q.id : q.questionId);
                    if (!this.answers[ackKey]) {
                        this.answers[ackKey] = {
                            questionId: ackKey,
                            questionType: QuestionType.Acknowledgement,
                            required: true,
                            isChecked: false,
                            text: '',
                            answerIds: null
                        };
                    }
                }
            }
        };

     
        const setAllAcks = (value: boolean) => {
            const answersMap = (this as any).answers || {};
            for (const k in answersMap) {
                const a = answersMap[k];
                if (a && a.questionType === QuestionType.Acknowledgement) {
                    a.isChecked = value;
                }
            }
        };

       
        ensureAllAckAnswers();

        return new Promise<boolean>((resolve) => {

            this.modal.setState(function (prev: any) {
                return { ...prev, options: { ...prev.options, maxSize: true } };
            });

            this.modal.showMessageBox({
                title: "",
                message: (
                    <div className={style.ackContainer}>
                        <div className={style.ackHeader} title={title}>{title}</div>
                        <div className={style.ackBody}>{message}</div>
                    </div>
                ),
                maxSize: true,
                buttons: [
                    {
                        text: "Decline",
                        onClick: () => {
                            setAllAcks(false);
                            this.setState({});
                            this.modal.hideDialog();
                            resolve(false);
                        }
                    },
                    {
                        text: "Accept",
                        onClick: () => {
                            setAllAcks(true);   
                            this.setState({});
                            this.modal.hideDialog();
                            resolve(true);
                        }
                    }
                ]
            });
        });
    }

    componentWillReceiveProps(p) {
        this.initializeQuestions(p.questions);
    }

    render() {
        return <div class={style.questionsContainer}>
            {this.state.questions.map(q => {
                switch (q.type) {
                    case QuestionType.Text:
                        return <TextBox value={q.defaultValue} label={q.text} name={"q" + q.id} onChange={(v) => this.onChange(q.id, v)} class={`${style.question} ${style.fullWidthTextBox}`} />
                    case QuestionType.Radio:
                        return <RadioButtonList value={q.defaultValue} label={q.text} name={"q" + q.id} options={q.options} onChange={(v) => this.onRadioCheckBoxListChange(q.id, [v])} class={`${style.yesNo} ${style.question}`} />
                    case QuestionType.YesNo:
                        return <YesNoRadioButtons value={q.defaultValue} label={q.text} name={"q" + q.id} onChange={(v) => this.onYesNoChange(q.id, v)} class={`${style.yesNo} ${style.question}`} />
                    case QuestionType.Checkbox:
                        return <CheckBox value={q.defaultValue} label={q.text} name={"q" + q.id} onChange={(v) => this.onCheckBoxChange(q.id, v)} class={`${style.checkbox} ${style.question}`} />
                    case QuestionType.CheckBoxList:
                        return <CheckBoxList value={q.defaultValue} label={q.text} name={"q" + q.id} options={q.options} onChange={(v) => this.onRadioCheckBoxListChange(q.id, v)} class={`${style.yesNo} ${style.question}`} />
                    case QuestionType.Document:
                        var type = this.getDocType(q.document);
                        if (type == DocType.Unknown)
                            return <List className={style.borderbottom}><List.LinkItem href={q.document} target="_blank"><List.TextContainer><List.PrimaryText>{q.text}</List.PrimaryText></List.TextContainer><List.ItemMeta>chevron_right</List.ItemMeta></List.LinkItem></List>
                        else
                            return <List className={style.borderbottom}><List.LinkItem onClick={() => { this.showDocToDisplay(q.document, type); this.onDocOpened(q.id); }}><List.TextContainer><List.PrimaryText>{q.text}</List.PrimaryText></List.TextContainer><List.ItemMeta>chevron_right</List.ItemMeta></List.LinkItem></List>
                    default:
                        return null
                }
            })}
            <div style="display:none"><TextBox value="" label="test" name="test" onChange={(v) => { }} class={`${style.question} ${style.fullWidthTextBox}`} /></div>
        </div>;
    }
}



// WEBPACK FOOTER //
// ./components/Questions/Questions.tsx